/**
 * FamilySidebar — Sidebar contextuelle
 * CAS A (famille active) : enfants de la famille
 * CAS B (page prioritaire) : liens rapides toutes familles
 * Classes CSS : hrl-sidebar, hrl-sidebar-item, hrl-sidebar-section-label (theme.css)
 */

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import {
  FAMILIES_META, FAMILIES_ORDER, SIDEBAR_ITEMS,
  getActiveFamily, canAccess,
} from './familyConfig';

export function FamilySidebar() {
  const location  = useLocation();
  const navigate  = useNavigate();
  const { user }  = useAuth();

  const activeFamily = getActiveFamily(location.pathname);

  return (
    <aside className="hrl-sidebar d-flex flex-column">

      {/* ── CAS A : famille active → ses enfants ──────────────────── */}
      {activeFamily !== null && (() => {
        const meta  = FAMILIES_META.find(f => f.id === activeFamily)!;
        const items = SIDEBAR_ITEMS[activeFamily].filter(
          item => canAccess(item.profils, user?.profil)
        );

        return (
          <>
            <div className="hrl-sidebar-section-label">
              <i className={`bi ${meta.icon} me-1`} />
              {meta.label}
            </div>
            <nav className="d-flex flex-column" style={{ gap: '1px' }}>
              {items.map(item => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/patients'}
                  className={({ isActive }) =>
                    `hrl-sidebar-item${isActive ? ' active' : ''}`
                  }
                >
                  <i className={`bi ${item.icon}`} />
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </>
        );
      })()}

      {/* ── CAS B : page prioritaire → liens rapides familles ─────── */}
      {activeFamily === null && (
        <>
          <div className="hrl-sidebar-section-label hrl-sidebar-section-label--neutral">
            Navigation
          </div>
          <nav className="d-flex flex-column" style={{ gap: '1px' }}>
            {FAMILIES_ORDER
              .filter(id => SIDEBAR_ITEMS[id].some(item => canAccess(item.profils, user?.profil)))
              .map(id => {
                const meta = FAMILIES_META.find(f => f.id === id)!;
                return (
                  <button
                    key={id}
                    className="hrl-sidebar-item d-flex align-items-center justify-content-between"
                    onClick={() => navigate(meta.landing)}
                  >
                    <span className="d-flex align-items-center gap-2">
                      <i className={`bi ${meta.icon}`} style={{ color: 'var(--purple-primary)' }} />
                      {meta.label}
                    </span>
                    <i
                      className="bi bi-chevron-right"
                      style={{ fontSize: '0.65rem', opacity: 0.35, flexShrink: 0 }}
                    />
                  </button>
                );
              })}
          </nav>
        </>
      )}
    </aside>
  );
}
